module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-epigraph element-without-heading",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "epigraph-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('i', [_vm._v("There was a very long incubation period for this story, which is deeply personal for me in several ways, including my being the parent of a remarkable Down syndrome son. When an editor at ")]), _vm._v("Stonecoast Review"), _c('i', [_vm._v(", Jess Flarity, solicited a story from me for ")]), _vm._v("Stonecoast Review "), _c('i', [_vm._v("#9, I took another, deeper, look at the story and finally realized what it needed and how I could get it done. With the help of Flarity and other editors at ")]), _vm._v("Stonecoast"), _c('i', [_vm._v(", the story clicked for us all. A couple of months later ")]), _vm._v("Locus"), _c('i', [_vm._v(" magazine reviewer Rich Horton liked the story well enough to call it a Recommended Read, and then also selected it for inclusion in his annual ")]), _vm._v("Best Science Fiction and Fantasy: 2019 "), _c('i', [_vm._v("anthology (Prime Books, 2019).")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ea2a77d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/introductiontotodayistoday.vue
// module id = 81
// module chunks = 0